/* Generated by scripts/generate.ts from src/locales. Do not edit by hand. */
import type { NamespaceSchema } from "../catalogue";

export interface ReallocationCopy {
  title: string;
  accountName: (args: { account: string | number }) => string;
  continue: string;
  rate: (args: { rate: string | number }) => string;
  monthsNotice: (args: { months: string | number }) => string;
  tray: {
    title: string;
    toDeal: string;
    toDealBody: string;
    toNoticePeriod: string;
    toNoticePeriodBody: (args: { dealName: string | number }) => string;
    toBank: string;
    toBankBody: string;
    toIsa: string;
    toIsaBody: string;
    openIsa: string;
    openIsaBody: string;
    isaMoveWaiting: string;
    outOfIsa: string;
    outOfIsaBody: string;
  };
  source: {
    from: string;
    to: string;
    intoIsa: string;
    fromBalance: (args: { account: string | number; amount: string | number }) => string;
    fromBalanceWithdrawing: (args: { account: string | number; amount: string | number; withdrawing: string | number }) => string;
    fromAmount: (args: { account: string | number; amount: string | number }) => string;
    toRate: (args: { account: string | number; rate: string | number }) => string;
    toAmountRate: (args: { account: string | number; amount: string | number; rate: string | number }) => string;
    toAmount: (args: { account: string | number; amount: string | number }) => string;
    toIsaTaxFree: string;
  };
  accountStep: {
    title: string;
    intro: string;
    introFromIsa: string;
    personalBody: string;
    isaBody: string;
    isaStaysBody: string;
    isaNote: (args: { taxYear: string | number }) => string;
    leaveIsaTitle: string;
    leaveIsaBody: string;
    introHeldBoth: (args: { deal: string | number }) => string;
    personalNote: string;
    isaAllowanceLeft: (args: { amount: string | number }) => string;
    isaNoAllowanceUsed: string;
  };
  dealStep: {
    movingFrom: string;
    title: string;
    intro: string;
    available: (args: { count: string | number }) => string;
    isaEligible: string;
    notIsaEligible: string;
    empty: string;
    heldInOne: (args: { account: string | number }) => string;
    heldInTwo: (args: { first: string | number; second: string | number }) => string;
    heldByCompany: string;
    loading: string;
    moveWaiting: string;
    landsInPersonal: string;
  };
  amountStep: {
    title: string;
    available: (args: { amount: string | number }) => string;
    isaLeft: (args: { amount: string | number }) => string;
    rateAfter: string;
    reallocationDate: string;
    dateToBeConfirmed: string;
    tooMuch: (args: { amount: string | number }) => string;
    belowMinimum: (args: { amount: string | number }) => string;
    overIsa: (args: { amount: string | number }) => string;
    isaAllowanceTitle: string;
    isaAnnual: string;
    isaUsed: (args: { taxYear: string | number }) => string;
    isaPending: string;
    isaCanReplace: string;
    isaLeftToInvest: string;
    isaReplaceable: (args: { amount: string | number }) => string;
    estimatedReceived: string;
    maximum: string;
    toDeal: (args: { deal: string | number }) => string;
    remainingEarns: string;
    beingWithdrawn: (args: { amount: string | number }) => string;
    overIsaTitle: string;
    overIsaBody: (args: { amount: string | number }) => string;
    isaCardCaption: string;
    isaReplacement: string;
    isaNewLeft: string;
    isaLeftAfter: string;
    isaReplacementBody: (args: { amount: string | number }) => string;
    approxRateToday: string;
    finalRateSetOn: string;
    leavesIsa: (args: { date: string | number; taxYear: string | number }) => string;
    leavesIsaNoDate: string;
  };
  fx: {
    callout: (args: { rate: string | number; date: string | number }) => string;
    calloutNoDate: (args: { rate: string | number }) => string;
  };
  reviewStep: {
    title: string;
    yourReallocation: string;
    agreeDates: (args: { noticeStarts: string | number; reallocationDate: string | number }) => string;
    agreeDatesNoEnd: (args: { noticeStarts: string | number }) => string;
    risksTitle: string;
    riskDeal: (args: { deal: string | number }) => string;
    riskFx: string;
    riskCapital: string;
    riskCancel: (args: { date: string | number }) => string;
    agreeLeaveIsa: string;
    leavesIsaTitle: string;
    leavesIsa: (args: { date: string | number; taxYear: string | number }) => string;
    leavesIsaNoDate: string;
    confirm: string;
    goBack: string;
    submitFailedTitle: string;
    submitFailedBody: string;
    convertsTitle: (args: { currency: string | number }) => string;
    rateTodayNoFees: (args: { rate: string | number }) => string;
    agreeDatesFx: (args: { date: string | number; currency: string | number }) => string;
    agreeDatesFxNoDate: (args: { currency: string | number }) => string;
  };
  fact: {
    noticeStarts: string;
    reallocationDate: string;
    rateDuringNotice: string;
    cancelUntil: string;
  };
  done: {
    eyebrow: string;
    title: string;
    toDeal: (args: { deal: string | number }) => string;
    amountOn: (args: { amount: string | number; date: string | number }) => string;
    nextTitle: string;
    dateToBeConfirmed: string;
    cancelNote: (args: { date: string | number }) => string;
    viewActivity: string;
    todayLine: string;
    lastDayLine: (args: { date: string | number }) => string;
    noticeLine: (args: { date: string | number; months: string | number; amount: string | number; rate: string | number }) => string;
    noticeLineNoTerm: (args: { date: string | number; amount: string | number; rate: string | number }) => string;
    reallocationLine: (args: { date: string | number; deal: string | number }) => string;
    reallocationLineNoDate: (args: { deal: string | number }) => string;
    startsEarning: (args: { rate: string | number }) => string;
    startsEarningNoRate: string;
    leavesIsaLine: (args: { date: string | number; taxYear: string | number }) => string;
  };
  isaSwitch: {
    toIsa: string;
    toPersonal: string;
    allowanceCaption: (args: { date: string | number }) => string;
    allowanceCaptionYear: (args: { taxYear: string | number }) => string;
    moneyMoves: string;
    remainingEarns: string;
    overAllowance: (args: { amount: string | number; date: string | number }) => string;
    overAllowanceYear: (args: { amount: string | number; taxYear: string | number }) => string;
    nextYearTitle: (args: { year: string | number }) => string;
    nextYearBody: (args: { date: string | number; taxYear: string | number }) => string;
    belowMinimum: (args: { amount: string | number }) => string;
    overBalance: (args: { amount: string | number }) => string;
    outCallout: (args: { date: string | number }) => string;
    outCalloutYear: (args: { date: string | number; taxYear: string | number }) => string;
    outCalloutYearPutBack: (args: { date: string | number }) => string;
    leavesCaption: string;
    isaBalanceAfter: string;
    putBackBy: (args: { date: string | number }) => string;
    newAllowanceUsed: string;
    toIsaAmount: (args: { amount: string | number }) => string;
    usesAllowance: (args: { amount: string | number; left: string | number; date: string | number }) => string;
    usesAllowanceYear: (args: { amount: string | number; taxYear: string | number; date: string | number }) => string;
    risksTitle: string;
    riskBoundary: (args: { date: string | number }) => string;
    riskAllowance: (args: { date: string | number }) => string;
    agreeDate: (args: { date: string | number }) => string;
    agreeYear: (args: { taxYear: string | number }) => string;
    doneInto: string;
    doneOut: string;
    doneMovesInto: (args: { date: string | number }) => string;
    doneMovesOut: (args: { date: string | number }) => string;
    donePutBack: (args: { date: string | number; taxYear: string | number }) => string;
    detailFailedAllowance: (args: { date: string | number }) => string;
    detailFailedAccount: (args: { date: string | number }) => string;
    whereItGoes: string;
    moved: (args: { date: string | number }) => string;
  };
  detail: {
    title: string;
    titleProcessing: string;
    titleCompleted: string;
    completedBody: (args: { amount: string | number; deal: string | number }) => string;
    status: (args: { status: string | number }) => string;
    whereItGoes: string;
    whereItMoved: string;
    leaves: (args: { date: string | number }) => string;
    left: (args: { date: string | number }) => string;
    movingOut: string;
    onItsWay: string;
    stillEarning: (args: { date: string | number }) => string;
    noticeStartedOn: (args: { date: string | number }) => string;
    earnsUntil: (args: { rate: string | number; date: string | number }) => string;
    earnsUntilNoDate: (args: { rate: string | number }) => string;
    cannotCancel: string;
    processingBody: (args: { date: string | number; from: string | number; to: string | number }) => string;
    processingBodyNoDate: (args: { from: string | number; to: string | number }) => string;
    arrives: (args: { date: string | number }) => string;
    arrived: string;
    datesToBeConfirmed: string;
    notSent: string;
    wontArrive: string;
    details: string;
    noticeStarts: string;
    cancelUntil: string;
    cancelled: string;
    cancelCta: string;
    cancelNote: (args: { date: string | number }) => string;
    loadFailed: string;
    retry: string;
    cancelUntilDate: (args: { date: string | number }) => string;
    fromStaysHere: string;
    toNotReallocated: string;
    requestedOn: (args: { date: string | number }) => string;
    cancelledTitle: string;
    cancelledOn: (args: { date: string | number }) => string;
    nothingReallocated: (args: { amount: string | number; deal: string | number }) => string;
    whatWasPlanned: string;
    makeNewReallocation: string;
    viewDeal: (args: { deal: string | number }) => string;
    failedTitle: string;
    failedOn: (args: { date: string | number }) => string;
    failedBody: (args: { amount: string | number; deal: string | number }) => string;
    fromNotReallocated: string;
    noticeStarted: string;
    noticeEnded: string;
    failed: string;
    chatWithSupport: string;
  };
  cancel: {
    title: string;
    body: (args: { deal: string | number }) => string;
    confirm: string;
    keep: string;
    failed: string;
    done: string;
  };
  earnings: {
    intro: string;
    optionReinvest: string;
    optionReinvestBody: string;
    optionWithdraw: string;
    optionWithdrawBody: string;
    optionWithdrawBodyAccount: (args: { last4: string | number }) => string;
    optionReallocate: string;
    optionReallocateBody: string;
    current: string;
    chooseDeal: string;
    noLongerTakes: (args: { deal: string | number }) => string;
    chooseToContinue: string;
    save: string;
    pickerTitle: string;
    pickerIntro: string;
    investedAtNextDeployment: string;
    chosenRate: (args: { rate: string | number }) => string;
    cardReallocating: string;
    cardMovingTo: (args: { deal: string | number }) => string;
    reallocateEarningsTo: string;
    useThisDeal: string;
    emptyTitle: string;
    emptyBody: string;
    browseDeals: string;
    startsOn: (args: { date: string | number }) => string;
    savedTitle: string;
    savedBody: (args: { month: string | number; deal: string | number }) => string;
    savedBodyNoMonth: (args: { deal: string | number }) => string;
  };
  errors: {
    loadTitle: string;
    loadBody: string;
    duplicatePending: string;
    overBalance: string;
    overIsa: string;
    isaSwitchFailed: string;
  };
  isaPending: {
    title: string;
    intro: (args: { amount: string | number }) => string;
    row: (args: { amount: string | number; deal: string | number }) => string;
    rowDetail: (args: { date: string | number; cancelDate: string | number }) => string;
    allowanceLine: (args: { amount: string | number }) => string;
  };
}

export const reallocationSchema: NamespaceSchema = {
  namespace: "reallocation",
  keys: {
    "title": [],
    "accountName": ["account"],
    "continue": [],
    "rate": ["rate"],
    "monthsNotice": ["months"],
    "tray.title": [],
    "tray.toDeal": [],
    "tray.toDealBody": [],
    "tray.toNoticePeriod": [],
    "tray.toNoticePeriodBody": ["dealName"],
    "tray.toBank": [],
    "tray.toBankBody": [],
    "tray.toIsa": [],
    "tray.toIsaBody": [],
    "tray.openIsa": [],
    "tray.openIsaBody": [],
    "tray.isaMoveWaiting": [],
    "tray.outOfIsa": [],
    "tray.outOfIsaBody": [],
    "source.from": [],
    "source.to": [],
    "source.intoIsa": [],
    "source.fromBalance": ["account", "amount"],
    "source.fromBalanceWithdrawing": ["account", "amount", "withdrawing"],
    "source.fromAmount": ["account", "amount"],
    "source.toRate": ["account", "rate"],
    "source.toAmountRate": ["account", "amount", "rate"],
    "source.toAmount": ["account", "amount"],
    "source.toIsaTaxFree": [],
    "accountStep.title": [],
    "accountStep.intro": [],
    "accountStep.introFromIsa": [],
    "accountStep.personalBody": [],
    "accountStep.isaBody": [],
    "accountStep.isaStaysBody": [],
    "accountStep.isaNote": ["taxYear"],
    "accountStep.leaveIsaTitle": [],
    "accountStep.leaveIsaBody": [],
    "accountStep.introHeldBoth": ["deal"],
    "accountStep.personalNote": [],
    "accountStep.isaAllowanceLeft": ["amount"],
    "accountStep.isaNoAllowanceUsed": [],
    "dealStep.movingFrom": [],
    "dealStep.title": [],
    "dealStep.intro": [],
    "dealStep.available": ["count"],
    "dealStep.isaEligible": [],
    "dealStep.notIsaEligible": [],
    "dealStep.empty": [],
    "dealStep.heldInOne": ["account"],
    "dealStep.heldInTwo": ["first", "second"],
    "dealStep.heldByCompany": [],
    "dealStep.loading": [],
    "dealStep.moveWaiting": [],
    "dealStep.landsInPersonal": [],
    "amountStep.title": [],
    "amountStep.available": ["amount"],
    "amountStep.isaLeft": ["amount"],
    "amountStep.rateAfter": [],
    "amountStep.reallocationDate": [],
    "amountStep.dateToBeConfirmed": [],
    "amountStep.tooMuch": ["amount"],
    "amountStep.belowMinimum": ["amount"],
    "amountStep.overIsa": ["amount"],
    "amountStep.isaAllowanceTitle": [],
    "amountStep.isaAnnual": [],
    "amountStep.isaUsed": ["taxYear"],
    "amountStep.isaPending": [],
    "amountStep.isaCanReplace": [],
    "amountStep.isaLeftToInvest": [],
    "amountStep.isaReplaceable": ["amount"],
    "amountStep.estimatedReceived": [],
    "amountStep.maximum": [],
    "amountStep.toDeal": ["deal"],
    "amountStep.remainingEarns": [],
    "amountStep.beingWithdrawn": ["amount"],
    "amountStep.overIsaTitle": [],
    "amountStep.overIsaBody": ["amount"],
    "amountStep.isaCardCaption": [],
    "amountStep.isaReplacement": [],
    "amountStep.isaNewLeft": [],
    "amountStep.isaLeftAfter": [],
    "amountStep.isaReplacementBody": ["amount"],
    "amountStep.approxRateToday": [],
    "amountStep.finalRateSetOn": [],
    "amountStep.leavesIsa": ["date", "taxYear"],
    "amountStep.leavesIsaNoDate": [],
    "fx.callout": ["rate", "date"],
    "fx.calloutNoDate": ["rate"],
    "reviewStep.title": [],
    "reviewStep.yourReallocation": [],
    "fact.noticeStarts": [],
    "fact.reallocationDate": [],
    "fact.rateDuringNotice": [],
    "fact.cancelUntil": [],
    "reviewStep.agreeDates": ["noticeStarts", "reallocationDate"],
    "reviewStep.agreeDatesNoEnd": ["noticeStarts"],
    "reviewStep.risksTitle": [],
    "reviewStep.riskDeal": ["deal"],
    "reviewStep.riskFx": [],
    "reviewStep.riskCapital": [],
    "reviewStep.riskCancel": ["date"],
    "reviewStep.agreeLeaveIsa": [],
    "reviewStep.leavesIsaTitle": [],
    "reviewStep.leavesIsa": ["date", "taxYear"],
    "reviewStep.leavesIsaNoDate": [],
    "reviewStep.confirm": [],
    "reviewStep.goBack": [],
    "reviewStep.submitFailedTitle": [],
    "reviewStep.submitFailedBody": [],
    "reviewStep.convertsTitle": ["currency"],
    "reviewStep.rateTodayNoFees": ["rate"],
    "reviewStep.agreeDatesFx": ["date", "currency"],
    "reviewStep.agreeDatesFxNoDate": ["currency"],
    "done.eyebrow": [],
    "done.title": [],
    "done.toDeal": ["deal"],
    "done.amountOn": ["amount", "date"],
    "done.nextTitle": [],
    "done.dateToBeConfirmed": [],
    "done.cancelNote": ["date"],
    "done.viewActivity": [],
    "done.todayLine": [],
    "done.lastDayLine": ["date"],
    "done.noticeLine": ["date", "months", "amount", "rate"],
    "done.noticeLineNoTerm": ["date", "amount", "rate"],
    "done.reallocationLine": ["date", "deal"],
    "done.reallocationLineNoDate": ["deal"],
    "done.startsEarning": ["rate"],
    "done.startsEarningNoRate": [],
    "done.leavesIsaLine": ["date", "taxYear"],
    "isaSwitch.toIsa": [],
    "isaSwitch.toPersonal": [],
    "isaSwitch.allowanceCaption": ["date"],
    "isaSwitch.allowanceCaptionYear": ["taxYear"],
    "isaSwitch.moneyMoves": [],
    "isaSwitch.remainingEarns": [],
    "isaSwitch.overAllowance": ["amount", "date"],
    "isaSwitch.overAllowanceYear": ["amount", "taxYear"],
    "isaSwitch.nextYearTitle": ["year"],
    "isaSwitch.nextYearBody": ["date", "taxYear"],
    "isaSwitch.belowMinimum": ["amount"],
    "isaSwitch.overBalance": ["amount"],
    "isaSwitch.outCallout": ["date"],
    "isaSwitch.outCalloutYear": ["date", "taxYear"],
    "isaSwitch.outCalloutYearPutBack": ["date"],
    "isaSwitch.leavesCaption": [],
    "isaSwitch.isaBalanceAfter": [],
    "isaSwitch.putBackBy": ["date"],
    "isaSwitch.newAllowanceUsed": [],
    "isaSwitch.toIsaAmount": ["amount"],
    "isaSwitch.usesAllowance": ["amount", "left", "date"],
    "isaSwitch.usesAllowanceYear": ["amount", "taxYear", "date"],
    "isaSwitch.risksTitle": [],
    "isaSwitch.riskBoundary": ["date"],
    "isaSwitch.riskAllowance": ["date"],
    "isaSwitch.agreeDate": ["date"],
    "isaSwitch.agreeYear": ["taxYear"],
    "isaSwitch.doneInto": [],
    "isaSwitch.doneOut": [],
    "isaSwitch.doneMovesInto": ["date"],
    "isaSwitch.doneMovesOut": ["date"],
    "isaSwitch.donePutBack": ["date", "taxYear"],
    "isaSwitch.detailFailedAllowance": ["date"],
    "isaSwitch.detailFailedAccount": ["date"],
    "isaSwitch.whereItGoes": [],
    "isaSwitch.moved": ["date"],
    "detail.title": [],
    "detail.titleProcessing": [],
    "detail.titleCompleted": [],
    "detail.completedBody": ["amount", "deal"],
    "detail.status": ["status"],
    "detail.whereItGoes": [],
    "detail.whereItMoved": [],
    "detail.leaves": ["date"],
    "detail.left": ["date"],
    "detail.movingOut": [],
    "detail.onItsWay": [],
    "detail.stillEarning": ["date"],
    "detail.noticeStartedOn": ["date"],
    "detail.earnsUntil": ["rate", "date"],
    "detail.earnsUntilNoDate": ["rate"],
    "detail.cannotCancel": [],
    "detail.processingBody": ["date", "from", "to"],
    "detail.processingBodyNoDate": ["from", "to"],
    "detail.arrives": ["date"],
    "detail.arrived": [],
    "detail.datesToBeConfirmed": [],
    "detail.notSent": [],
    "detail.wontArrive": [],
    "detail.details": [],
    "detail.noticeStarts": [],
    "detail.cancelUntil": [],
    "detail.cancelled": [],
    "detail.cancelCta": [],
    "detail.cancelNote": ["date"],
    "detail.loadFailed": [],
    "detail.retry": [],
    "detail.cancelUntilDate": ["date"],
    "detail.fromStaysHere": [],
    "detail.toNotReallocated": [],
    "detail.requestedOn": ["date"],
    "detail.cancelledTitle": [],
    "detail.cancelledOn": ["date"],
    "detail.nothingReallocated": ["amount", "deal"],
    "detail.whatWasPlanned": [],
    "detail.makeNewReallocation": [],
    "detail.viewDeal": ["deal"],
    "detail.failedTitle": [],
    "detail.failedOn": ["date"],
    "detail.failedBody": ["amount", "deal"],
    "detail.fromNotReallocated": [],
    "detail.noticeStarted": [],
    "detail.noticeEnded": [],
    "detail.failed": [],
    "detail.chatWithSupport": [],
    "cancel.title": [],
    "cancel.body": ["deal"],
    "cancel.confirm": [],
    "cancel.keep": [],
    "cancel.failed": [],
    "cancel.done": [],
    "earnings.intro": [],
    "earnings.optionReinvest": [],
    "earnings.optionReinvestBody": [],
    "earnings.optionWithdraw": [],
    "earnings.optionWithdrawBody": [],
    "earnings.optionWithdrawBodyAccount": ["last4"],
    "earnings.optionReallocate": [],
    "earnings.optionReallocateBody": [],
    "earnings.current": [],
    "earnings.chooseDeal": [],
    "earnings.noLongerTakes": ["deal"],
    "earnings.chooseToContinue": [],
    "earnings.save": [],
    "earnings.pickerTitle": [],
    "earnings.pickerIntro": [],
    "earnings.investedAtNextDeployment": [],
    "earnings.chosenRate": ["rate"],
    "earnings.cardReallocating": [],
    "earnings.cardMovingTo": ["deal"],
    "earnings.reallocateEarningsTo": [],
    "earnings.useThisDeal": [],
    "earnings.emptyTitle": [],
    "earnings.emptyBody": [],
    "earnings.browseDeals": [],
    "earnings.startsOn": ["date"],
    "earnings.savedTitle": [],
    "earnings.savedBody": ["month", "deal"],
    "earnings.savedBodyNoMonth": ["deal"],
    "errors.loadTitle": [],
    "errors.loadBody": [],
    "errors.duplicatePending": [],
    "errors.overBalance": [],
    "errors.overIsa": [],
    "errors.isaSwitchFailed": [],
    "isaPending.title": [],
    "isaPending.intro": ["amount"],
    "isaPending.row": ["amount", "deal"],
    "isaPending.rowDetail": ["date", "cancelDate"],
    "isaPending.allowanceLine": ["amount"],
  },
};
